import { breakpoints } from 'config/config';
import styled from 'styled-components';

export const StyledFarmSearchFilterSettings = styled.div`
  .fsf-loading {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 200px;
  }

  .fsf-content {
    padding: 16px 0;
  }

  .fsf-section {
    h3 {
      margin: 0 0 8px 0;
      font-size: 16px;
      font-weight: 600;
    }

    .description {
      margin: 0 0 16px 0;
      color: ${({ theme }) => theme.descriptionText};
      font-size: 14px;
    }
  }

  .fsf-fields {
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-top: 16px;

    .ant-form-item {
      margin-bottom: 0;
    }

    .distance-field {
      display: flex;
      flex-direction: column;
      gap: 8px;

      label {
        font-weight: 500;
        font-size: 14px;
      }

      .ant-input-number-affix-wrapper {
        width: 33%;
      }

      .help-text {
        font-size: 12px;
        color: ${({ theme }) => theme.dimmedTextColor};
      }
    }

    .address-field {
      margin-top: 8px;
    }
  }

  @media only screen and (max-width: ${breakpoints.lg}px) {
    .fsf-fields {
      .distance-field {
        .ant-input-number-affix-wrapper {
          width: 100%;
        }
      }
    }
  }
`;
